module.exports = __webpack_public_path__ + "img/ava-2.ee4225d5.png";